import type { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={25}
		viewBox="0 0 24 25"
		fill="none"
		{...props}
	>
		<title>Filter</title>
		<path stroke="#212322" strokeLinecap="square" strokeWidth={1.5} d="M5 8.5h7M18 8.5h1" />
		<circle cx={15} cy={8.5} r={2.25} stroke="#212322" strokeWidth={1.5} />
		<path stroke="#212322" strokeLinecap="square" strokeWidth={1.5} d="M19 16.5h-7M6 16.5H5" />
		<circle
			cx={3}
			cy={3}
			r={2.25}
			stroke="#212322"
			strokeWidth={1.5}
			transform="matrix(-1 0 0 1 12 13.5)"
		/>
	</svg>
);
export { SvgComponent as Filter24 };
